<template>
  <div class="gx-dir">
    <!-- 平台选择 -->
    <div class="gx-dir__platform">
      <span class="gx-dir__platform-label">选择平台</span>
      <div class="gx-dir__platform-tabs">
        <button
          v-for="p in platforms"
          :key="p.value"
          class="gx-dir__platform-tab"
          :class="{ 'gx-dir__platform-tab--on': platform === p.value }"
          @click="platform = p.value"
        >{{ p.label }}</button>
      </div>
    </div>

    <!-- 顶栏 Tab -->
    <div class="gx-dir__tabs">
      <button
        class="gx-dir__tab"
        :class="{ 'gx-dir__tab--on': activeTab === 'direction' }"
        @click="activeTab = 'direction'"
      >AI定方向</button>
      <button
        class="gx-dir__tab"
        :class="{ 'gx-dir__tab--on': activeTab === 'history' }"
        @click="activeTab = 'history'"
      >历史记录</button>
    </div>

    <!-- 步骤条 -->
    <div class="gx-dir__steps">
      <template  v-for="(s, i) in steps">
        <div :key="s.id" class="gx-dir__step"
          :class="{ 'gx-dir__step--on': currentStep === s.id, 'gx-dir__step--done': currentStep > s.id }" >
          <div class="gx-dir__step-dot">{{ s.id }}</div>
          <div class="gx-dir__step-label">{{ s.label }}</div>
        </div>
        <div :key="'line'+s.id" v-if="i < steps.length - 1" class="gx-dir__step-line" :class="{'gx-dir__step-line--done': currentStep > s.id} "></div>
      </template>
    </div>

    <template v-if="activeTab === 'direction'">
      <!-- 两栏内容 -->
      <div class="gx-dir__grid">
        <!-- 基础配置 -->
        <div class="gx-dir__card">
          <div class="gx-dir__card-head">
            <span class="gx-dir__card-bar"></span>
            <span class="gx-dir__card-title">基础配置</span>
          </div>

          <!-- 选品范围 -->
          <div class="gx-dir__field">
            <div class="gx-dir__field-label">
              <span class="gx-dir__req">*</span>选品范围
              <span class="gx-dir__field-tip">选择本次定方向的范围，支持全类目</span>
            </div>
            <div class="gx-dir__cate-groups" :key="selectedCateIds.length">
              <button
                v-for="sc in cateList"
                :key="sc.id"
                class="gx-dir__cate-btn"
                :class="{ 'gx-dir__cate-btn--on': selectedCateIds.includes(sc.id) }"
                :disabled="sc.id!='all'&&selectedCateIds.includes('all')"
                @click="handleSelectCate(sc)"
              >{{ sc.name }}</button>
            </div>
          </div>

          <!-- 二级类目 -->
          <div v-if="selectedCateIds.length&&!selectedCateIds.includes('all')" class="gx-dir__field">
            <div class="gx-dir__field-label">二级类目选择 <span class="gx-dir__field-tip">可不选、可多选、可全选；不选默认全部纳入</span></div>
            <div class="gx-dir__cate-groups gx-dir__cate-groups--mi">
              <button
                v-for="g in selectedCate"
                :key="g.id"
                class="gx-dir__cate-btn gx-dir__cate-btn--mi"
                :class="{ 'gx-dir__cate-btn--on': activeOneCate === g.id }"
                @click="clickOneCate(g)"
              >
                {{ g.name }}<span class="gx-dir__cate-count" v-if="selSubCate?.[g.id]?.length>0">({{ selSubCate?.[g.id]?.length??0 }})</span>
                 <span class="icon-triangle">{{activeOneCate === g.id?'▲':'▼'}}</span>
              </button>
            </div>
            <div class="gx-dir__cate-sub" v-if="activeOneCate&&currentSubCate.length">
              <div class="gx-dir__sub-list">
                <label v-for="sub in currentSubCate" :key="sub" class="gx-dir__check" @click="clickSubCate(sub)">
                  <span class="gx-dir__check-box" :class="{ 'gx-dir__check-box--on': selSubCate?.[activeOneCate]?.includes(sub) }">
                    <svg v-if="selSubCate?.[activeOneCate]?.includes(sub)" width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                  </span>
                   <span>{{ sub }}</span>
                </label>
              </div>
              <div class="gx-dir__sub-actions">
                <button class="gx-dir__sub-btn gx-dir__sub-btn--primary" @click="selectAllSub">全选</button>
                <button class="gx-dir__sub-btn" @click="clearSub">清除</button>
                <span class="gx-dir__sub-total">已选{{ selSubCate?.[activeOneCate]?.length??0 }}个</span>
              </div>
            </div>
          </div>

          <!-- 热度时间 -->
          <div class="gx-dir__field">
            <div class="gx-dir__field-label">热度时间</div>
            <div class="gx-dir__radios">
              <label v-for="t in hotTimeList" :key="t.value" class="gx-dir__radio">
                <input type="radio" v-model="hotTime" :value="t.value" />
                <span class="gx-dir__radio-dot"></span>
                <span>{{ t.label }}</span>
              </label>
            </div>
          </div>

          <!-- 选品策略 -->
          <div class="gx-dir__field">
            <div class="gx-dir__field-label">选品策略</div>
            <div class="gx-dir__strategies">
              <label
                v-for="st in strategyList"
                :key="st.id"
                class="gx-dir__strategy"
                :class="{ 'gx-dir__strategy--on': strategy === st.id }"
              >
                <input type="radio" v-model="strategy" :value="st.id" />
                <span class="gx-dir__strategy-dot"></span>
                <span class="gx-dir__strategy-body">
                  <span class="gx-dir__strategy-name">{{ st.name }}</span>
                  <span class="gx-dir__strategy-desc">{{ st.desc }}</span>
                </span>
              </label>
            </div>
          </div>

          <!-- 产品总数量 -->
          <div class="gx-dir__field">
            <div class="gx-dir__field-label">产品总数量</div>
            <div class="gx-dir__count">
              <input type="number" v-model.number="productCount" class="gx-dir__count-input" />
              <span class="gx-dir__count-unit">件</span>
            </div>
          </div>
        </div>

        <!-- 店铺授权 -->
        <div class="gx-dir__card gx-dir__card--auth">
          <div class="gx-dir__card-head">
            <span class="gx-dir__card-bar"></span>
            <span class="gx-dir__card-title">店铺授权</span>
          </div>

          <div class="gx-dir__tip-bar">
            <span class="gx-dir__tip-icon">📋</span>
            <span>请确认所选类目已完成店铺授权。未授权类目不会纳入本次定方向任务，您可前往「店铺管理」完成授权。</span>
          </div>

          <ul class="gx-dir__auth-list">
            <li v-for="a in authList" :key="a.name" class="gx-dir__auth-item">
              <span class="gx-dir__auth-check">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2 6.5l3 3 5-6" stroke="#52C41A" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </span>
              <span>{{ a.name }}已授权</span>
            </li>
          </ul>

          <div class="gx-dir__client">
            <div class="gx-dir__client-head">
              <div class="gx-dir__client-info">
                <span class="gx-dir__client-icon">🖥️</span>
                <div>
                  <div class="gx-dir__client-name">观星树桌面客户端</div>
                  <div class="gx-dir__client-desc">连接桌面客户端后，勾选类目和店铺以启动定方向任务</div>
                </div>
              </div>
              <span class="gx-dir__client-status" :class="{ 'gx-dir__client-status--on': clientConnected }">
                {{ clientConnected ? '已连接' : '未连接' }}
              </span>
            </div>
            <button class="gx-dir__client-btn" @click="clientConnected = !clientConnected">
              {{ clientConnected ? '断开连接' : '连接客户端' }}
            </button>
          </div>
        </div>
      </div>

      <!-- 底部操作栏 -->
      <div class="gx-dir__footer">
        <button class="gx-dir__btn gx-dir__btn--ghost" @click="onCancel">取消</button>
        <div class="gx-dir__footer-info">已选 <b>{{ selectedCateIds.length }}</b> 个类目 · <b>0</b> 个店铺</div>
        <button class="gx-dir__btn gx-dir__btn--primary" @click="onNext">下一步：子类目分配</button>
      </div>
    </template>

    <template v-else>
      <div class="gx-dir__empty">
        <div class="gx-dir__empty-icon">📄</div>
        <div class="gx-dir__empty-text">暂无历史记录</div>
      </div>
    </template>
    <under-development ref="underDevelopmentRef"></under-development>
  </div>
</template>

<script>

import UnderDevelopment from "@/components/newUi/UnderDevelopment.vue";

export default {
  name: 'AiSetDirectionPage',
  components: {UnderDevelopment},
  data() {
    return {
      platform: 'douyin',
      activeTab: 'direction',
      currentStep: 1,
      platforms: [
        { value: 'douyin', label: '抖店' },
        { value: 'wechat', label: '微信小店' }
      ],
      steps: [
        { id: 1, label: '基础配置与店铺授权' },
        { id: 2, label: '子类目分配确认' },
        { id: 3, label: '属性拆分·关键词·价格段' },
        { id: 4, label: '全类目汇总看板' },
        { id: 5, label: '分析报告' }
      ],
      cateList: [
        { id: 'all', name: '全类目' },
        {
          id: 'nvzhuang', name: '女装',
          children: ['T恤', '连衣裙', '半身裙', '外套', '针织衫', '裤装', '内衣', '正装', '衬衫']
        },
        {
          id: 'nanzhuang', name: '男装',
          children: ['T恤', '衬衫', '外套', '裤装', '正装', '内衣']
        },
        { id: 'tongzhuang', name: '童装' },
        { id: 'sports', name: '运动户外' },
        { id: 'digital', name: '数码' },
        { id: 'home', name: '家居' },
        { id: 'beauty', name: '美妆' },
        { id: 'food', name: '食品' }
      ],
      selectedCate:[],
      selSubCate:{},
      activeOneCate: '',//选中的一级类目
      hotTime: '30',
      hotTimeList: [
        { value: '1', label: '1天' },
        { value: '7', label: '7天' },
        { value: '30', label: '30天' }
      ],
      strategy: 'blueOcean',
      strategyList: [
        { id: 'highestPay', name: '用户支付金额最高', desc: '大盘主流款，流量最大' },
        { id: 'fastestGrowth', name: '成交增速最快', desc: '增长潜力款，趋势优先' },
        { id: 'blueOcean', name: '蓝海需求供给比最大', desc: '低竞争款，易起量' }
      ],
      productCount: 10000,
      authList: [
        { name: '数据访问权限' },
        { name: '商品推送权限' },
        { name: '库存同步权限' }
      ],
      clientConnected: false
    }
  },
  computed: {
    selectedCateIds(){
      return this.selectedCate.map(i=>i.id)||[]
    },
    currentSubCate() {
      return this.selectedCate.find(i=>i.id===this.activeOneCate)?.children??[]

    }
  },
  created() {
    this.$nextTick(()=>{
      this.$refs.underDevelopmentRef.show()
    })
  },
  methods: {
    handleSelectCate(cate) {
      const index = this.selectedCate.findIndex(i=>i.id===cate.id)
      if(index>-1){
        this.selectedCate=this.selectedCate.filter(i=>i.id!=cate.id)
      }else if(cate.id==='all'){
        this.selectedCate=[cate]
      }else{
        this.selectedCate.push(cate)
        this.$set(this.selSubCate,cate.id,[])
      }
      this.clickOneCate(cate,true)
    },
    clickOneCate(cate,isTop){
      this.activeOneCate =this.activeOneCate === cate.id?'':cate.id
    },
    clickSubCate(sub){
      const index = this.selSubCate[this.activeOneCate].findIndex(i=>i==sub)
      if(index>-1){
        this.selSubCate[this.activeOneCate].splice(index,1)
      }else{
        this.selSubCate[this.activeOneCate].push(sub)
      }
    },
    selectAllSub() {
      this.selSubCate[this.activeOneCate] = this.currentSubCate.slice()
    },
    clearSub() {
      this.selSubCate[this.activeOneCate] = []
    },
    onCancel() {
      this.$message({ message: '已取消配置', type: 'info' })
    },
    onNext() {
      if (this.currentStep < this.steps.length) {
        this.currentStep++
        this.$message({ message: `进入第 ${this.currentStep} 步：${this.steps[this.currentStep - 1].label}`, type: 'success' })
      }
    }
  }
}
</script>

<style scoped>
.gx-dir {
  color: #1A1A2E;
  font-family: 'Noto Sans SC', sans-serif;
  margin: -20px -20px 0;
  height: calc(100% + 40px);
  display: flex;
  flex-direction: column;
}
/* 平台选择 */
.gx-dir__platform {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgb(255, 255, 255);
  border-bottom: 1px solid rgb(224, 224, 236);
  padding: 10px 24px;
  flex-shrink: 0;

}
.gx-dir__platform-label {
  font-family: "Noto Sans SC", sans-serif;
  font-size: 12px;
  color: rgb(102, 102, 102);
  margin-right: 4px;
}
.gx-dir__platform-tabs {
  display: flex;
  gap: 8px;
}
.gx-dir__platform-tab {
  height: 32px;
  padding: 0 20px;
  border-radius: 6px;
  border: 1.5px solid rgb(224, 224, 236);
  background: rgb(250, 250, 250);
  cursor: pointer;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 13px;
  font-weight: 400;
  color: rgb(26, 26, 46);
  opacity: 1;
  transition: 0.15s;
}
.gx-dir__platform-tab--on {
  background: rgb(255, 245, 245);
  border: 1.5px solid var(--gx-red);
  color: var(--gx-red);
  font-weight: 600;
}
/* 顶栏 Tab */
.gx-dir__tabs {
  display: flex;
  align-items: center;
  background: rgb(255, 255, 255);
  border-bottom: 1px solid rgb(224, 224, 236);
  padding: 0 24px;
  flex-shrink: 0;
}
.gx-dir__tab {
  height: 44px;
  padding: 0 18px;
  border-bottom: 2px solid transparent;
  background: transparent;
  cursor: pointer;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 13px;
  font-weight: 400;
  color: rgb(102, 102, 102);
  transition: 0.15s;
  white-space: nowrap;
}
.gx-dir__tab--on {
  color: var(--gx-red);
  font-weight: 600;
  border-bottom: 2px solid var(--gx-red);
}
/* 步骤条 */
.gx-dir__steps {
  background: rgb(255, 255, 255);
  border-bottom: 1px solid rgb(224, 224, 236);
  padding: 14px 24px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 6px;
}
.gx-dir__step {
  display: flex;
  align-items: center;
  gap: 6px;
}
.gx-dir__step-dot {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 700;
  font-family: "JetBrains Mono", monospace;
  background: rgb(224, 224, 236);
  color: rgb(153, 153, 153);
  flex-shrink: 0;
  transition: 0.2s;
}

.gx-dir__step-label {
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
  color: rgb(153, 153, 153);
  font-weight: 400;
  white-space: nowrap;
}

.gx-dir__step-line {
  flex: 1 1 0%;
  height: 1px;
  background: rgb(224, 224, 236);
  min-width: 8px;
  transition: background 0.2s;
}
.gx-dir__step--on .gx-dir__step-label{
  color: var(--gx-red);
}
.gx-dir__step--on .gx-dir__step-dot {
  background: #C8443C;
  color: #fff;
}
.gx-dir__step--done .gx-dir__step-label{
  color: var(--gx-green);
}
.gx-dir__step--done .gx-dir__step-dot {
  background: var(--gx-green);
  color: #fff;
}
.gx-dir__step-line--done{
  background: var(--gx-green);
}
/* 两栏 */
.gx-dir__grid {
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: 1.4fr 1fr;
  gap: 14px;
  margin-bottom: 16px;
  overflow: auto;
  padding: 16px 20px;

}
.gx-dir__card {
  background: rgb(255, 255, 255);
  border-radius: 10px;
  border: 1px solid rgb(224, 224, 236);
  padding: 16px 18px;
  box-shadow: rgba(0, 0, 0, 0.04) 0 1px 6px;
}
.gx-dir__card--auth .gx-dir__card-title { color: #C8443C; }
.gx-dir__card-head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 18px;
}
.gx-dir__card-bar {
  width: 3px;
  height: 14px;
  background: #C8443C;
  border-radius: 2px;
}
.gx-dir__card-title {
  font-size: 15px;
  font-weight: 600;
  color: #1A1A2E;
}
/* 字段 */
.gx-dir__field {
  margin-bottom: 14px;
}
.gx-dir__field-label {
  font-family: "Noto Sans SC", sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: var(--gx-black);
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 4px;
}
.gx-dir__req {
  color: #C8443C;
}
.gx-dir__field-tip {
  font-size: 11px;
  color: var(--gx-gray);
  font-weight: normal;
}

/* 类目 */
.gx-dir__cate-groups {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.gx-dir__cate-groups--mi{
  gap: 4px;
}
.gx-dir__cate-btn {
  height: 28px;
  padding: 0 12px;
  border-radius: 5px;
  border: 1.5px solid rgb(224, 224, 236);
  background: rgb(250, 250, 250);
  cursor: pointer;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
  font-weight: 500;
  color: var(--gx-black);
  transition: 0.15s;
}
.gx-dir__cate-btn:disabled{
  color: var(--gx-gray);
  cursor: not-allowed;
  opacity: 0.5;
}
.gx-dir__cate-btn--on {
  background: rgb(255, 245, 245);
  border-color: #C8443C;
  color: #C8443C;
}
.gx-dir__cate-btn--mi{
  height: 26px;
  padding: 0px 10px;
  border-radius: 4px;
  transition: 0.13s;
}

.gx-dir__cate-btn .icon-triangle {
  margin-left: 3px;
  color: rgb(153, 153, 153);
  font-size: 10px;
  transition: transform .2s;
}
.gx-dir__cate-sub{
  margin-top: 8px;
  padding: 10px 12px;
  border-radius: 7px;
  background: rgb(250, 250, 250);
  border: 1px solid rgb(224, 224, 236);
}
.gx-dir__sub-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 8px;
}
.gx-dir__check {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: var(--gx-black);
  cursor: pointer;
}
.gx-dir__check-box {
  width: 13px;
  height: 13px;
  border-radius: 3px;
  border: 1.5px solid #D0D5DD;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  flex-shrink: 0;
}
.gx-dir__check-box--on {
  background: #C8443C;
  border-color: #C8443C;
}
.gx-dir__sub-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  border-top: 1px solid rgb(224, 224, 236);
  padding-top: 8px;
}
.gx-dir__sub-btn {
  height: 24px;
  padding: 0px 10px;
  border-radius: 4px;
  border: 1px solid rgb(224, 224, 236);
  background: rgb(255, 255, 255);
  cursor: pointer;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
  color: rgb(102, 102, 102);
}
.gx-dir__sub-btn--primary{
  border: 1px solid var(--gx-red);
  background: rgb(255, 245, 245);
  color: var(--gx-red);
}
.gx-dir__sub-total {
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
  color: rgb(153, 153, 153);
  line-height: 24px;
}
/* Radio */
.gx-dir__radios {
  display: flex;
  gap: 20px;
}
.gx-dir__radio {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #4A4A6A;
  cursor: pointer;
}
.gx-dir__radio input { display: none; }
.gx-dir__radio-dot {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 1.5px solid #D0D5DD;
  background: #fff;
  box-sizing: border-box;
  position: relative;
}
.gx-dir__radio input:checked + .gx-dir__radio-dot {
  border-color: #C8443C;
}
.gx-dir__radio input:checked + .gx-dir__radio-dot::after {
  content: '';
  position: absolute;
  inset: 2px;
  border-radius: 50%;
  background: #C8443C;
}
/* 策略卡片 */
.gx-dir__strategies {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.gx-dir__strategy {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border: 1px solid #E1E5EE;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  transition: all .16s;
}
.gx-dir__strategy input { display: none; }
.gx-dir__strategy-dot {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 1.5px solid #D0D5DD;
  background: #fff;
  box-sizing: border-box;
  position: relative;
  flex-shrink: 0;
  margin-top: 2px;
}
.gx-dir__strategy--on .gx-dir__strategy-dot {
  border-color: #C8443C;
}
.gx-dir__strategy--on .gx-dir__strategy-dot::after {
  content: '';
  position: absolute;
  inset: 2px;
  border-radius: 50%;
  background: #C8443C;
}
.gx-dir__strategy--on {
  border-color: #C8443C;
  background: #FDECEC;
}
.gx-dir__strategy-body {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.gx-dir__strategy-name {
  font-family: "Noto Sans SC", sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: rgb(26, 26, 46);
}
.gx-dir__strategy-desc {
  font-family: "Noto Sans SC", sans-serif;
  font-size: 10px;
  color: rgb(153, 153, 153);
  margin-top: 2px;
}
.gx-dir__strategy--on .gx-dir__strategy-name{
  color: var(--gx-red);
}
/* 数量 */
.gx-dir__count {
  display: flex;
  align-items: center;
  gap: 8px;
}
.gx-dir__count-input {
  width: 120px;
  height: 32px;
  padding: 0 10px;
  border: 1px solid #DDE2EC;
  border-radius: 4px;
  font-size: 13px;
  color: #1A1A2E;
  outline: none;
  font-family: 'JetBrains Mono', monospace;
}
.gx-dir__count-unit {
  font-size: 13px;
  color: #5C6B73;
}
/* 授权 */
.gx-dir__tip-bar {
  display: flex;
  gap: 8px;
  padding: 10px 12px;
  background: #E8F3FF;
  border: 1px solid #B7DBFF;
  border-radius: 6px;
  font-size: 12px;
  color: #1A1A2E;
  line-height: 1.6;
  margin-bottom: 16px;
}
.gx-dir__tip-icon { flex-shrink: 0; }
.gx-dir__auth-list {
  list-style: none;
  padding: 0;
  margin: 0 0 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.gx-dir__auth-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #1A1A2E;
}
.gx-dir__auth-check {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #E8FAE8;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
/* 客户端 */
.gx-dir__client {
  border: 1px solid #EEF1F6;
  border-radius: 6px;
  padding: 14px;
  background: #FAFBFC;
}
.gx-dir__client-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 10px;
}
.gx-dir__client-info {
  display: flex;
  gap: 10px;
  align-items: flex-start;
}
.gx-dir__client-icon {
  font-size: 20px;
}
.gx-dir__client-name {
  font-size: 13px;
  font-weight: 600;
  color: #1A1A2E;
  margin-bottom: 2px;
}
.gx-dir__client-desc {
  font-size: 12px;
  color: #9AA3B0;
  line-height: 1.5;
}
.gx-dir__client-status {
  font-size: 12px;
  color: #9AA3B0;
  flex-shrink: 0;
}
.gx-dir__client-status--on {
  color: #52C41A;
}
.gx-dir__client-btn {
  padding: 5px 14px;
  background: #1677FF;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: opacity .16s;
}
.gx-dir__client-btn:hover { opacity: .88; }
/* 底部 */
.gx-dir__footer {
  flex-shrink: 0;
  background: #fff;
  border-top: 1px solid rgb(224, 224, 236);
  padding: 12px 24px;
  position: sticky;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.gx-dir__btn {
  padding: 7px 20px;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
  transition: all .16s;
  border: 1px solid transparent;
}
.gx-dir__btn--ghost {
  background: #fff;
  border-color: #DDE2EC;
  color: #5C6B73;
}
.gx-dir__btn--ghost:hover {
  border-color: #C8443C;
  color: #C8443C;
}
.gx-dir__btn--primary {
  background: #C8443C;
  color: #fff;
}
.gx-dir__btn--primary:hover { opacity: .9; }
.gx-dir__footer-info {
  font-size: 13px;
  color: #5C6B73;
}
.gx-dir__footer-info b {
  color: #C8443C;
  font-weight: 600;
}
/* 空状态 */
.gx-dir__empty {
  background: #fff;
  border: 1px solid #E1E5EE;
  border-radius: 8px;
  padding: 80px 24px;
  text-align: center;
}
.gx-dir__empty-icon {
  font-size: 48px;
  margin-bottom: 12px;
}
.gx-dir__empty-text {
  font-size: 14px;
  color: #9AA3B0;
}
</style>
